import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import './plugins'
import vuetify from './plugins/vuetify'
import {sync} from 'vuex-router-sync'

const apiUrl = process.env.VUE_APP_API_BASE_URL || "http://acesso.engenharia.ufjf.br:81";

sync(store, router)
Vue.config.productionTip = false
Vue.use(Vuelidate)

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
}

// the only way of passing slots to children components (DataGrid): https://github.com/vuejs/vue/pull/7765
Vue.prototype._b = (function (bind) {
  return function (data, tag, value, asProp, isSync) {
    if (value && value.$scopedSlots) {
      data.scopedSlots = value.$scopedSlots
      delete value.$scopedSlots
    }
    return bind.apply(this, arguments)
  }
})(Vue.prototype._b)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
